import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
  checkboxContainer: {
    textAlign: 'left'
  },
  checkbox: {
    height: 'unset'
  }
});

export default makeStyles(styles);
